export default {
  assumptionCostingList: {
    method: 'post',
    url: '/costing/assumption-driver/list'
  },
  createAssumptionDriver: {
    method: 'post',
    url: '/costing/assumption-driver/create'
  },
  editAssumptionDriver: {
    method: 'put',
    url: '/costing/assumption-driver/update/ID'
  },
  getDetailAssumptionDriver: {
    method: 'get',
    url: '/costing/assumption-driver/detail/ID'
  },
  deleteAssumptionDriver: {
    method: 'delete',
    url: '/costing/assumption-driver/delete/ID'
  },
  getAll: {
    method: 'get',
    url: '/costing/assumption-driver/all'
  },
  archiveGasoline: {
    method: 'delete',
    url: '/costing/assumption-driver/archive'
  },
  restoreGasoline: {
    method: 'put',
    url: '/costing/assumption-driver/restore'
  }
}
